import { Typography } from "@joonapp/web-shared"
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom"

import ProfileDropdown from "./components/profileDropdown/ProfileDropdown"
import { useAnalytics } from "./hooks/useAnalytics"
import useMobile from "./hooks/useMobile"
import useUserRole from "./hooks/useUserRole"
import ChannelsByCoachView from "./pages/admin/CoachesPage"
import CreateAccount from "./pages/auth/CreateAccount"
import SignIn from "./pages/auth/SignIn"
import ClientPage from "./pages/clients/ClientPage"
import MessagesTab from "./pages/clients/MessagesTab"
import RoutinesTab from "./pages/clients/routines/RoutinesTab"
import SessionsTab from "./pages/clients/sessions/SessionsTab"
import Home from "./pages/home/Home"
import Settings from "./pages/settings/Settings"

export const Routing = () => {
  useAnalytics()

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />}>
          <Route path=":coachingGroupId" element={<ClientPage />}>
            <Route path="messages" element={<MessagesTab />} />
            <Route path="sessions" element={<SessionsTab />} />
            <Route path="routines" element={<RoutinesTab />} />
          </Route>
        </Route>
        <Route path="/coaches" element={<ChannelsByCoachView />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/auth/signin" element={<SignIn />} />
        <Route path="/auth/create" element={<CreateAccount />} />
      </Route>
    </Routes>
  )
}

const NAV_HEIGHT = 60

const Layout = () => {
  const isMobile = useMobile()
  const { isSupervisor, isAdmin } = useUserRole()
  const showNavbar = (isSupervisor || isAdmin) && !isMobile
  const contentHeight = showNavbar ? `calc(100dvh - ${NAV_HEIGHT}px)` : "100dvh"

  return (
    <div className="h-[100dvh] max-h-[100dvh] overflow-hidden w-[100vw]">
      {showNavbar ? <Navbar /> : null}
      <div className="flex flex-1 flex-row" style={{ height: contentHeight }}>
        <Outlet />
      </div>
    </div>
  )
}

const Navbar = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isSupervisor = pathname.includes("coaches")

  return (
    <div
      className="w-full bg-white border-b border-gray-200 flex flex-row justify-between items-center px-6"
      style={{ height: NAV_HEIGHT }}
    >
      <div className="flex flex-row gap-2">
        <NavButton
          text="Supervisor"
          isSelected={isSupervisor}
          onClick={() => navigate("/coaches")}
        />
        <NavButton
          text="Client"
          isSelected={!isSupervisor}
          onClick={() => navigate("/")}
        />
      </div>
      <ProfileDropdown />
    </div>
  )
}

const NavButton = ({
  text,
  isSelected,
  onClick,
}: {
  text: string
  isSelected: boolean
  onClick: () => void
}) => {
  return (
    <button onClick={onClick}>
      <div
        className={`flex flex-row gap-2 items-center p-2 rounded-md ${
          isSelected ? "bg-neutral-100" : ""
        }`}
      >
        <Typography variant="bodySmall">{text}</Typography>
      </div>
    </button>
  )
}
